// src/components/admin/ChipEstadoCuenta.js
//
// Pinta EstadoCuenta de seg.AspNetUsers de forma consistente en los tres
// listados del panel. Los valores los define el backend en AuthService y
// CuentaService: ACTIVO -> DADA_BAJA -> ANONIMIZADA.
//
// SIN_CUENTA no es un estado de Identity: lo produce el backend cuando la
// entidad existe (un cliente, un tenant) pero todavia no hay AspNetUser
// vinculado. Hoy pasa con los domiciliarios pre-registrados por el negocio;
// en un veci o un negocio significa que quedo huerfano y hay que mirarlo.

import React from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';

const MAPA = {
  ACTIVO:      { label: 'Activo',       color: 'success' },
  DADA_BAJA:   { label: 'Dada de baja', color: 'error'   },
  ANONIMIZADA: { label: 'Anonimizada',  color: 'default' },
  SIN_CUENTA:  { label: 'Sin cuenta',   color: 'warning' },
};

const AYUDA = {
  DADA_BAJA:   'El usuario eliminó su cuenta. Puede reactivarla dentro de la ventana de 60 días.',
  ANONIMIZADA: 'Pasó la ventana de reactivación y los datos personales fueron borrados.',
  SIN_CUENTA:  'La entidad existe pero no tiene usuario de acceso vinculado.',
};

export default function ChipEstadoCuenta({ estado, correoConfirmado, bloqueado }) {
  const cfg = MAPA[estado] || { label: estado || '—', color: 'default' };
  const ayuda = AYUDA[estado];

  const principal = <Chip size="small" label={cfg.label} color={cfg.color} />;

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {ayuda ? <Tooltip title={ayuda}>{principal}</Tooltip> : principal}

      {/* Solo tienen sentido sobre una cuenta viva. */}
      {estado === 'ACTIVO' && bloqueado && (
        <Tooltip title="Bloqueada por intentos fallidos de inicio de sesión.">
          <Chip size="small" label="Bloqueado" color="error" variant="outlined" />
        </Tooltip>
      )}
      {estado === 'ACTIVO' && correoConfirmado === false && (
        <Tooltip title="No ha confirmado su correo. Si la puerta de correo está activa, no puede entrar.">
          <Chip size="small" label="Sin confirmar" color="warning" variant="outlined" />
        </Tooltip>
      )}
    </Stack>
  );
}
